
const list = [
    {
        introduce: "浙江传媒学院",
        name: "",
        text: "传媒实践教学与艺术创作中心",
        imgIcon: "",
        caseVideo: "",
        coverImg: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20260625/WPS%E5%9B%BE%E7%89%87(2)_bWKUABFiVG.png",
        title: "项目背景",
        content: "随幻科技与浙江传媒学院实践创作中心签署战略协议，共建国内首个AI+XR数字制作产学研融合基地，在基地内部署了随幻MPRO智能演播室、MBOX数字化影棚和随幻3D数字资产AI创作平台三大核心系统，并将随幻科技的自研工具与课程融入了浙传《虚实融合创作实践S》课堂中，来促成从技术到人才的共同数字化升级。",
        serviceContentimg: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20260625/WPS%E5%9B%BE%E7%89%87(1)_zzAQUWxrXw.png",
        serviceContenttitle: "服务内容",
        serviceContent: "暂无",
        projectHighlightsimg: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20260625/WPS%E5%9B%BE%E7%89%87_lHpCDLaIjo.png",
        projectHighlightstitle: "项目亮点",
        // projectHighlightsimg2: '',
        projectHighlights: "暂无",

    },
    {
        introduce: "AI+XR未来影像创作中心",
        name: "",
        text: "大连理工大学",
        imgIcon: "",
        caseVideo: "",
        coverImg: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20260625/WPS%E5%9B%BE%E7%89%87_OmwgeLJltW.png",
        title: "项目背景",
        content: "随幻科技为大连理工大学量身打造了集XR数字演播技术和AI人工智能技术于一体的“AI+XR未来影像创作中心”。该中心深度融合了XR虚拟、智能交互与实时渲染能力，全面服务于视听传媒及影视艺术等专业课程的创新教学需求。极大地丰富了课堂教学内容与形式。这不仅显著提升了教学效率与学生的理解深度，也为培养适应数字内容与智能创作时代的复合型技术人才构建了国内领先的实践教学与创新能力孵化基地。",
        serviceContentimg: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20260625/WPS%E5%9B%BE%E7%89%87_OmwgeLJltW.png",
        serviceContenttitle: "服务内容",
        serviceContent: "暂无",
        projectHighlightsimg: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20260625/WPS%E5%9B%BE%E7%89%87(1)_EJSHNvOdZi.png",
        projectHighlightstitle: "项目亮点",
        // projectHighlightsimg2: '',
        projectHighlights: "暂无",

    },
    {
        introduce: "新疆师范高等专科学校",
        name: "",
        text: "新媒体专业",
        imgIcon: "",
        caseVideo: "",
        coverImg: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20260625/WPS%E5%9B%BE%E7%89%87_FbdbBuohNi.png",
        title: "项目背景",
        content: "随幻科技为新疆师范高等专科学校精心部署了MPRO与MBOX两套数字虚拟智能演播系统，全面赋能学校融媒体、数字媒体、广播影视等前沿学科的建设与发展。该专业级演播空间，整合了实时渲染、虚拟场景合成与智能互动等先进技术，为学生提供了从内容策划、虚拟制作到成品输出的全流程实践平台。它极大地丰富了教学手段，将抽象理论转化为直观、可操作的创造性实践，有效激发了学生的创新思维与实操能力。这一举措不仅深化了产教融合，也为培养适应媒体融合趋势的高素质技术技能人才奠定了坚实的硬件与教学基础。",
        serviceContentimg: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20260625/WPS%E5%9B%BE%E7%89%87(1)_vQoRPrXMVh.png",
        serviceContenttitle: "服务内容",
        serviceContent: "暂无",
        projectHighlightsimg: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20260625/WPS%E5%9B%BE%E7%89%87(2)_VWwZtVPWdW.png",
        projectHighlightstitle: "项目亮点",
        // projectHighlightsimg2: '',
        projectHighlights: "暂无",

    },
    {
        introduce: "AI+XR智慧教学平台",
        name: "",
        text: "黑龙江建筑职业技术学院",
        imgIcon: "",
        caseVideo: "",
        coverImg: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20260625/WPS%E5%9B%BE%E7%89%87_qXTDfXoOKy.png",
        title: "项目背景",
        content: "随幻科技为黑龙江建筑职业技术学院量身打造了集智慧演播室与“AI+XR”（人工智能与扩展现实）技术于一体的先进教学平台。该系统深度融合了虚拟仿真、智能交互与实时渲染能力，全面服务于建筑信息化、设计表现、工程管理等专业课程的创新教学需求。通过高拟真的虚拟施工场景、沉浸式的空间漫游与智能化的方案推演，该系统将复杂的建筑原理与工艺流程转化为直观、可交互的动态演示，极大地丰富了课堂教学内容与形式。这不仅显著提升了教学效率与学生的理解深度，也为培养适应智能建造时代的复合型技术人才构建了国内领先的实践教学与创新能力孵化基地",
        serviceContentimg: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20260625/WPS%E5%9B%BE%E7%89%87(1)_cGgQzwGIDh.png",
        serviceContenttitle: "服务内容",
        serviceContent: "暂无",
        projectHighlightsimg: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20260625/WPS%E5%9B%BE%E7%89%87(2)_MCFjydKUaw.png",
        projectHighlightstitle: "项目亮点",
        // projectHighlightsimg2: '',
        projectHighlights: "暂无",

    },
    {
        introduce: "数字媒体专业",
        name: "",
        text: "武汉职业技术大学",
        imgIcon: "",
        caseVideo: "",
        coverImg: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20260625/WPS%E5%9B%BE%E7%89%87_FcGhsFAuXS.png",
        title: "项目背景",
        content: "随幻科技为武汉职业技术大学数字媒体专业成功打造了先进的数字虚拟影视实训室。该实训室集成了高性能虚拟制作系统、实时渲染引擎与专业动作捕捉设备，构建了一个涵盖虚拟场景搭建、角色动画、实时合成与交互设计的沉浸式教学环境。它不仅将前沿的虚拟制片流程引入课堂，为学生提供了从创意策划到影视级成品输出的全链路实践平台，更通过项目制教学，显著提升了学生的技术应用能力与团队协作水平。这一创新实训空间的建立，极大地丰富了数字媒体专业的教学内涵，有效衔接了产业需求与人才培养，为学生的专业成长与职业发展奠定了坚实的技术与实践基础。",
        serviceContentimg: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20260625/WPS%E5%9B%BE%E7%89%87(1)_lsNvPsDwlP.png",
        serviceContenttitle: "服务内容",
        serviceContent: "暂无",
        projectHighlightsimg: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20260625/WPS%E5%9B%BE%E7%89%87(2)_xiqqXaBfNw.png",
        projectHighlightstitle: "项目亮点",
        // projectHighlightsimg2: '',
        projectHighlights: "暂无",

    },

    {
        introduce: "电商直播课程使用小幻演播厅，虚拟演播厅整套系统搭建，P2，整套技术系统",
        name: "",
        text: "宁乡职业中专",
        imgIcon: "",
        caseVideo: "",
        coverImg: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20260625/WPS%E5%9B%BE%E7%89%87_tTYxRBFhjv.png",
        title: "项目背景",
        content: "随幻科技为宁乡职业中专量身打造了先进的智能演播教学空间，包括随幻MPRO智能演播室与便携式小幻演播厅。这套专业级解决方案，全面满足了学校电商直播、文旅导游、融媒体技术等课程的教学与专业录播需求。通过高度集成、操作简便的系统，学生得以在拟真环境中进行直播话术、场景调度、内容制作等全方位实训。这不仅显著提升了课堂教学的互动性与实效性，也为学生构建了连接理论与市场的桥梁，为其未来在电商、新媒体、数字文旅等领域的职业发展提供了强有力的技术支撑与实践平台。",
        serviceContentimg: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20260625/WPS%E5%9B%BE%E7%89%87(1)_wwYhigolGa.png",
        serviceContenttitle: "服务内容",
        serviceContent: "暂无",
        projectHighlightsimg: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20260625/WPS%E5%9B%BE%E7%89%87(2)_AFwfoybsjJ.png",
        projectHighlightstitle: "项目亮点",
        // projectHighlightsimg2: '',
        projectHighlights: "暂无",

    },

    {
        introduce: "数字媒体艺术设计专业",
        name: "",
        text: "长沙文创艺术职业学院",
        imgIcon: "",
        caseVideo: "",
        coverImg: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20260625/WPS%E5%9B%BE%E7%89%87(3)_xPiltalRZD.png",
        title: "项目背景",
        content: "随幻科技为长沙文创艺术职业学院提供了专业级的动态捕捉设备支持，助力学院在虚拟现实与交互设计领域的教学革新。通过高精度动作捕捉系统，学生可以将理论知识与实际操作紧密结合，实时体验虚拟角色驱动、手势交互设计等技术应用。这一举措不仅丰富了课堂教学内容，也提升了学生的实践能力和创意实现水平，为他们今后从事游戏开发、动画制作、数字艺术等行业打下坚实基础，体现了校企合作在培养新时代数字创意人才方面的重要价值。",
        serviceContentimg: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20260625/WPS%E5%9B%BE%E7%89%87(4)_JyBCretWYM.png",
        serviceContenttitle: "服务内容",
        serviceContent: "暂无",
        projectHighlightsimg: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20260625/WPS%E5%9B%BE%E7%89%87(5)_kjbPTXvLFH.png",
        projectHighlightstitle: "项目亮点",
        // projectHighlightsimg2: '',
        projectHighlights: "暂无",

    },

    {
        introduce: "杭州学军中学桐庐学校",
        name: "",
        text: "桐庐学校",
        imgIcon: "",
        caseVideo: "",
        coverImg: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20260625/WPS%E5%9B%BE%E7%89%87(6)_EQkXsXiRvd.png",
        title: "项目背景",
        content: "随幻科技为杭州学军中学桐庐学校部署了先进的MPRO智能演播室，旨在以创新科技深度赋能基础教育。该系统集成了虚拟背景合成、多机位切换、实时交互等功能，能将传统课堂升级为沉浸式、高互动的多媒体教学空间。通过这套系统，教师能够轻松创设虚拟实验室、历史场景、地理地貌等丰富教学情境，使抽象知识变得生动可视，极大地优化了课堂教学模式，激发了学生的探索欲与创造力。这不仅是对教学内容的极大丰富，更是对教学方法和学习体验的一次革新，充分体现了科技与教育融合的价值，为培养学生适应未来的综合素养提供了强有力的平台支撑。",
        serviceContentimg: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20260625/WPS%E5%9B%BE%E7%89%87(7)_sYMKypAqnD.png",
        serviceContenttitle: "服务内容",
        serviceContent: "暂无",
        projectHighlightsimg: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20260625/WPS%E5%9B%BE%E7%89%87(8)_CtTKLfUUwN.png",
        projectHighlightstitle: "项目亮点",
        // projectHighlightsimg2: '',
        projectHighlights: "暂无",

    },

    {
        introduce: "各街道老年大学",
        name: "",
        text: "上海长宁区老年大学",
        imgIcon: "",
        caseVideo: "",
        coverImg: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20260625/WPS%E5%9B%BE%E7%89%87(9)_lziMlNBuzg.png",
        title: "项目背景",
        content: "随幻科技为长宁区老年大学量身打造了“随幻空间”智慧学习系统，以其高度集成、操作简便的特性，为老年教育注入了新的活力。该系统通过沉浸式虚拟场景、直观的可视化界面与便捷的交互操作，有效降低了数字化学习的技术门槛。借助该系统，各类课程内容得以以生动、形象的方式进行呈现，无论是历史文化漫游、健康知识讲解，还是艺术欣赏与手工教学，都变得更加直观有趣。这不仅显著提升了老年学员的学习兴趣与课堂参与度，也帮助他们在轻松愉快的氛围中掌握新技能、拓展社交圈，真正实现了科技赋能老年教育，让银发族也能畅享数字时代的学习乐趣与成果。",
        serviceContentimg: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20260625/WPS%E5%9B%BE%E7%89%87(10)_zIaOWxbBYS.png",
        serviceContenttitle: "服务内容",
        serviceContent: "暂无",
        projectHighlightsimg: "https://mrstage-oss.oss-cn-shanghai.aliyuncs.com/nocode/20260625/WPS%E5%9B%BE%E7%89%87(11)_sEgKvgnmUx.png",
        projectHighlightstitle: "项目亮点",
        // projectHighlightsimg2: '',
        projectHighlights: "暂无",

    },
  
]
export default list